import { render, staticRenderFns } from "./CountryMove.vue?vue&type=template&id=a9b4deaa&"
import script from "./CountryMove.vue?vue&type=script&lang=js&"
export * from "./CountryMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports